<div class="otp-container p-10 pb-15 w-full" dir="ltr">
  <input *ngFor="let i of digitIndices; trackBy: trackByIndex"
    #otpBox
    type="tel"
    class="otp-input"
    inputmode="numeric"
    pattern="[0-9]*"
    maxlength="1"
    autocomplete="one-time-code"
    [ngModel]="values[i]"
    (ngModelChange)="values[i] = $event"
    (input)="onInput($event, i)"
    (keydown)="onKeyDown($event, i); onBackspace($event, i)"
    (paste)="onPaste($event)" />
</div>